import { styled } from '@mui/material/styles';

export const Container = styled('div')({
  width: '40em',
  padding: '2em',
  paddingTop: '4em',
  paddingBottom: '4em',
});
